const Navbar = () => {
    return (
        <nav>
            <ul>
                <li><a href="#home">Features</a></li>
                <li><a href="#home">Team</a></li>
                <li><a href="#home">Sign in</a></li>
            </ul>
        </nav>
    )
}
export default Navbar